import { useHistory, useLocation } from "react-router-dom";
import queryString from "qs";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";
import { PayableImportBatchFilter } from "./components/TablePayableImportBatches/filters/types";

export const BULK_IMPORTS_ROOT_PATH = "/member/imports" as const;

// payables (v3 — /v3/platform/batches, type PayableImport)

export const PARAMETER_BATCH_ID = "batchId";

export const PATH_IMPORT_PAYABLES =
  `${BULK_IMPORTS_ROOT_PATH}/payables` as const;
export const PATH_IMPORT_PAYABLES_START =
  `${PATH_IMPORT_PAYABLES}/start` as const;
export const PATH_IMPORT_PAYABLES_BATCH =
  `${PATH_IMPORT_PAYABLES}/:${PARAMETER_BATCH_ID}` as const;
export const PATH_IMPORT_PAYABLES_BATCH_HISTORY =
  `${PATH_IMPORT_PAYABLES_BATCH}/history` as const;

export const routeHelpersImportPayables = createRouteHelpers<
  never,
  { search: { filter?: PayableImportBatchFilter } }
>(PATH_IMPORT_PAYABLES);

export const routeHelpersImportPayablesStart = createRouteHelpers(
  PATH_IMPORT_PAYABLES_START
);

export const routeHelpersImportPayablesBatch = createRouteHelpers<
  { batchId: string },
  { state: { showBatchCreatedModal?: boolean } }
>(PATH_IMPORT_PAYABLES_BATCH);

export const routeHelpersImportPayablesBatchHistory = createRouteHelpers<{
  batchId: string;
}>(PATH_IMPORT_PAYABLES_BATCH_HISTORY);

// contractors ([LEGACY] still on the v1 bulk-collaborator batch API)

const useGoToDetailsPath = (path: string) => {
  const history = useHistory();

  return (bulkBatchId: string, state?: any) => {
    const url = path.replace(":bulkBatchId", bulkBatchId);
    history.push({
      pathname: url,
      state
    });
  };
};

export const BULK_IMPORT_CONTRACTORS_BATCHES =
  `${BULK_IMPORTS_ROOT_PATH}/collaborators` as const;
export const BULK_IMPORT_CONTRACTORS_START =
  `${BULK_IMPORT_CONTRACTORS_BATCHES}/start` as const;
export const BULK_IMPORT_CONTRACTORS_BATCH_DETAILS =
  `${BULK_IMPORT_CONTRACTORS_BATCHES}/:bulkBatchId` as const;
export const BULK_IMPORT_CONTRACTORS_BATCH_EVENT_HISTORY =
  `${BULK_IMPORT_CONTRACTORS_BATCH_DETAILS}/history` as const;

export const useGoToContractorBatches = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  // if year is not present in query params, add current year
  let search = location.search;
  if (!queryParams.year) {
    search = queryString.stringify({
      ...queryParams,
      year: new Date().getFullYear()
    });
  }
  return () => {
    history.push({
      pathname: BULK_IMPORT_CONTRACTORS_BATCHES,
      search
    });
  };
};

export const useGoToContractorImportStart = () => {
  const history = useHistory();
  const queryFeatureFlags = useQueryFeatureFlags();
  return () => {
    if (queryFeatureFlags.data?.newBulkImporterUI) {
      history.push(BULK_IMPORT_CONTRACTORS_START);
    } else {
      history.push("/member/invoices/contacts/collaborators/bulk-create/info");
    }
  };
};

export const useGoToContractorBatchDetails = () =>
  useGoToDetailsPath(BULK_IMPORT_CONTRACTORS_BATCH_DETAILS);

export const useGoToContractorBatchEventHistory = () =>
  useGoToDetailsPath(BULK_IMPORT_CONTRACTORS_BATCH_EVENT_HISTORY);
